var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"ce-to-top-button btn btn-secondary rounded-circle px-0 py-0 border-0",on:{"click":_vm.scroll}},[_c('ad-icon-chevron',{attrs:{"size":"l","direction":"up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }